import React from 'react';
import { titleCase, get } from "@dex/bubl-helpers";
import CampAthletesApi from './CampAthletesApi';

let settings;

export default settings = {
    key: 'camp/athletes',
    zone: 'camp',
    path: '/camp/athletes',
    title: "Camp Athletes",
    endpoint: CampAthletesApi.endpoint,
    modelName: 'CampAthletes',
    idKey: 'id',
    primaryKey: 'name',
    indexCaps: ["viewCampAthletes"],
    viewCaps: ["viewCampAthletes"],
    createCaps: ["createCampAthletes"],
    updateCaps: ["updateCampAthletes"],
    indexTitle: (routeName, params, users) => {

        let title: string = settings.title;

        if (params && params.name) title = title + " / " + titleCase(params.name);

        return title;

    },
    indexTabs: (routeName, params, users) => {

        return [
            {
                label: "All",
                path: settings.path,
                caps: settings.indexCaps
            },
            {
                label: "Add New",
                path: settings.path + "/create",
                caps: settings.createCaps
            },
        ]

    },
    indexButtons: (routeName, params, users) => {

        return [
            {
                label: "Add New",
                path: settings.path + '/create',
                caps: settings.createCaps
            }
        ]

    },
    indexTabCounts: (routeName, params, dontation) => {

        return settings.endpoint + "/getCounts";

    },
    indexFetch: CampAthletesApi.get,
    indexFetchParams: (routeName, params, users) => {

        const filters: any = { where: {}, include: ['user'], order: ['created.date DESC'], limit: 10, skip: 0 };

        if (params && params.status) filters.where.status = { inq: [params.status] };

        return filters;

    },
    indexQuickSearch: (routeName, params, users) => {

        const fields = ['name', 'email', 'idNumber', 'phone'];

        return fields;

    },
    indexSearchFields: (routeName, params, users) => {

        const fields = [
            {
                label: "Name",
                key: "name",
                type: "text",
            },
            {
                label: "Email",
                key: "email",
                type: "text",
            },
            {
                label: "ID Number",
                key: "idNumber",
                type: "text"
            },
            {
                label: "Gender",
                key: "gender",
                type: "choice",
                options:[
                    { value: "male", label: "Male"},
                    { value: "female", label: "Female"},
                ]
            },
        ];

        return fields;

    },

    indexColumns: (routeName, params, users) => {

        const columns = [
            {
                label: "Name",
                key: "this",
                format: "ModelLink",
            },
            {
                label: "User",
                key: "user",
                format: "ModelLink",
            },
            {
                label: "Email",
                key: "email",
            },
            {
                label: "Phone",
                key: "phone",
            },
            {
                label: "ID Number",
                key: "idNumber",
            },
            {
                label: "Gender",
                key: "gender",
                format: "titleCase",
            },
            {
                label: "Date of Birth",
                key: "dateOfBirth",
                format: "date",
            },
            {
                label: "Created Date",
                key: "created",
                format: "OnAndBy",
                sort: "created.date",
                alignEnd: true
            },
            {
                label: "Actions",
                key: "actions",
                alignEnd: true,
                format: "actions",
                api: CampAthletesApi,
                settings: settings,
            }
        ];

        return columns;

    },

    indexExportFormats: (routeName, params, user) => {

        const formats = [
            { value: "campAthletes", label: "Camp Athletes" }
        ];

        return formats;

    },

    singleFetch: CampAthletesApi.getOne,
    singleFetchParams: (routeName, params, users, fetch) => {

        const filters = { include: ['user'] };

        return filters;

    },
    singleTitle: (routeName, params, users, fetch) => {

        let title: string = "Loading...";

        const complete = get(fetch, 'complete');
        const error = get(fetch, 'error');
        const data = get(fetch, 'data');

        if (error) title = "Error";
        else if (data) title = data[settings.primaryKey];
        else if (complete && !data) title = "Not Found";

        return title;

    },
    singleTabs: (routeName, params, users, fetch) => {

        const path = settings.path + "/" + params.id;

        return [
            {
                label: "View",
                path: path + "/view"
            },
            {
                label: "Edit",
                path: path + "/edit",
                caps: settings.updateCaps
            },
        ]

    },
};